/**
 * Small inline badges shared across the venue detail page (ports of the
 * design's NBFhBadge + NBTeacherEye).
 *
 * - FhBadge marks a field mirrored to FareHarbor (change it there too).
 * - TeacherEye marks whether a logistics field shows on the teacher day-of
 *   card or stays internal.
 */
import { Users } from 'lucide-react';

export function FhBadge() {
  return (
    <span
      title="Mirrored to FareHarbor — change it there too"
      style={{
        fontSize: 8.5,
        fontWeight: 700,
        letterSpacing: '.06em',
        padding: '1px 5px',
        borderRadius: 4,
        background: 'var(--nb-warn-soft)',
        color: 'var(--nb-warn)',
        whiteSpace: 'nowrap',
      }}
    >
      FH
    </span>
  );
}

export function TeacherEye({ on }: { on: boolean }) {
  return (
    <span
      title={on ? 'Shown on the teacher day-of card' : 'Internal — hidden from teachers'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        color: on ? 'var(--nb-primary)' : 'var(--nb-faint)',
        whiteSpace: 'nowrap',
      }}
    >
      <Users size={10} />
      {on ? 'teachers see this' : 'internal'}
    </span>
  );
}
